import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ListViewContainer = styled.div`
  height: calc(100% - 40px);
`;
